import { Alert, Snackbar } from '@mui/material';
import { useToast } from '../../hooks';

// eslint-disable-next-line @typescript-eslint/ban-types
export type ToastProps = {};

export const Toast = (props: ToastProps) => {
  const toast = useToast();

  return (
    <Snackbar
      open={toast.open}
      onClose={() => toast.hide()}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert className="text-sm" severity={toast.severity} variant="filled">
        {toast.message}
      </Alert>
    </Snackbar>
  );
};
